import React from "react";
import ResolutionPicker from "./ResolutionPicker";

function VoucherCallout({ voucher }) {
  if (!voucher) return null;
  return (
    <div className="border border-emerald-700 bg-emerald-50 p-3" data-testid="voucher-issued">
      <div className="label-mono">Voucher issued</div>
      <div className="text-sm font-mono mt-1">
        <div><b>ID:</b> {voucher.id}</div>
        <div><b>Client:</b> {voucher.client_id}</div>
        {voucher.campaign_id && <div><b>Campaign:</b> {voucher.campaign_id}</div>}
        <div><b>Expires:</b> {new Date(voucher.expires_at).toLocaleString()}</div>
        <div className="text-[11px] text-zinc-600 mt-1">
          Auto-redeems on the next matching lead intake for this client
          {voucher.campaign_id ? " and campaign" : ""}.
        </div>
      </div>
    </div>
  );
}

/**
 * Reviewer decision form. Includes the resolution-type picker, per-status
 * side fields (credit amount / voucher expiry / replacement id) and a
 * post-submit voucher callout.
 */
export default function BadLeadReviewForm({ form, setForm, statuses, voucher, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="brut-card mt-4 p-5 space-y-4" data-testid="review-form">
      <div className="font-chivo font-bold uppercase tracking-tight">Review action</div>
      <ResolutionPicker form={form} setForm={setForm} />

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="label-mono">New status</label>
          <select data-testid="review-status" value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
            className="w-full border border-black px-2 py-1.5 mt-1">
            {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        {form.status === "credit_issued" && (
          <div>
            <label className="label-mono">Credit amount ($)</label>
            <input data-testid="review-credit" type="number" step="0.01"
              value={form.credit_amount}
              onChange={(e) => setForm({ ...form, credit_amount: e.target.value })}
              className="w-full border border-black px-2 py-1.5 mt-1" />
          </div>
        )}
        {form.status === "replacement_approved" && (
          <div>
            <label className="label-mono">Voucher expires in (days)</label>
            <input data-testid="review-expires-days" type="number" min={1} max={365}
              value={form.replacement_expires_days}
              onChange={(e) => setForm({ ...form, replacement_expires_days: e.target.value })}
              className="w-full border border-black px-2 py-1.5 mt-1" />
            <div className="text-[10px] text-zinc-500 mt-1">Defaults to 90 days</div>
          </div>
        )}
        {form.status === "replacement_delivered" && (
          <>
            <div>
              <label className="label-mono">Replacement credit ($)</label>
              <input type="number" step="0.01"
                value={form.replacement_credit_amount}
                onChange={(e) => setForm({ ...form, replacement_credit_amount: e.target.value })}
                className="w-full border border-black px-2 py-1.5 mt-1" />
            </div>
            <div>
              <label className="label-mono">Replacement lead ID</label>
              <input value={form.replacement_lead_id}
                onChange={(e) => setForm({ ...form, replacement_lead_id: e.target.value })}
                className="w-full border border-black px-2 py-1.5 mt-1" />
            </div>
          </>
        )}
      </div>
      <div>
        <label className="label-mono">Review notes</label>
        <textarea rows={3} data-testid="review-notes"
          value={form.review_notes}
          onChange={(e) => setForm({ ...form, review_notes: e.target.value })}
          className="w-full border border-black px-3 py-2 mt-1" />
      </div>

      <VoucherCallout voucher={voucher} />

      <button data-testid="review-submit" type="submit"
        className="bg-black text-white border border-black px-4 py-2 uppercase text-xs tracking-widest font-bold hover:translate-x-[2px] hover:translate-y-[2px] hover:brut-shadow-sm transition-transform duration-100">
        Save review
      </button>
    </form>
  );
}
